<template>
  <div class="product-table multi-report-table">
    <h2></h2>

    <table class="table  is-narrow">
      <thead>
      <tr>
        <th v-for="(column, key) in table.config" v-if="!column.disabled" :key="key" v-html="column.label"></th>
      </tr>
      </thead>
      <tbody>
      <template v-for="(product, productIndex) in table.data">
        <tr v-for="multiRowIndex in _.get(product, table.multiRowPath, 1)"
            :key="productIndex + '-' + multiRowIndex"
            :class="{parentRow: multiRowIndex === 1, childRow: multiRowIndex !== 1, odd: productIndex%2 === 0, even: productIndex%2 !== 0}">
          <tablefield
            v-for="(column, columnIndex) in table.config"
            v-if="multiRowIndex === 1 || (column.path && column.path.includes('[]'))"
            :key="productIndex + '-' + multiRowIndex + '-' + columnIndex"
            :column="column"
            :product="product"
            :rowspan="getRowSpan(multiRowIndex,column,table, product)"
            :secondary-index="multiRowIndex - 1"
          ></tablefield>
        </tr>
      </template>
      </tbody>
    </table>

    <!--    <div class="fineprint table-time" v-if="showTime">{{ time }}</div>-->
  </div>
</template>

<script>
import Tablefield from "../table-field/FieldContainer.vue"
import {Table} from "../../model/table/Table"

export default {
  components: {Tablefield},
  name: 'multi-report-table',
  props: {
    table: {
      type: Table,
      required: true
    },
    showTime: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  computed: {
    time() {
      return this.moment().format('[Stand:] DD. MMMM YYYY, HH:mm [Uhr]')
    }
  },
  methods: {
    getRowSpan(multiRowIndex, column, table, product) {
      if (multiRowIndex === 1 && this.checkPaths(column)) {
        return _.get(product, table.multiRowPath, 1)
      }
    },
    checkPaths(column) {
      if (column.path && !column.path.includes('[]')) {
        return true
      } else if (!column.path && column.decoratorOptions.lines) {
        return column.decoratorOptions.lines.reduce((sum, el) => {
          return sum || !el.path.includes('[]')
        }, false)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// TableMultiReport.vue?422f83f2